import { searchModels, createModel, updateModel, deleteModel, restoreModel, getModel, getRevisions, duplicateModel, replaceTags, forceDeleteModel } from '../../../../redux/DefaultModelActions';
import { dispatchClearState, dispatchError, dispatchLoading, dispatchSuccess } from '../../../../redux/utils';
import { APIBase, APIDelete, APIGet, APIPost } from '../../../../services/API';

const model = 'Asset';
const route = '/v1/asset';

export const searchAssets = (page, limit, search, view, args) => searchModels(model, route, page, limit, search, view, args);
export const createAsset = (args) => createModel(model, route, args);
export const updateAsset = (id, args) => updateModel(model, route, id, args);
export const deleteAsset = (id) => deleteModel(model, route, id);
export const restoreAsset = (id) => restoreModel(model, route, id);
export const getAsset = (id) => getModel(model, route, id);
export const getAssetRevision = (id) => getRevisions(model, route, id);
export const duplicateAsset = (id) => duplicateModel(model, route, id);
export const forceDeleteAsset = (id) => forceDeleteModel(model, route, id);

export const searchViewAssets = (page, limit, search, view, args, viewId) => {
    return searchModels(model, `/v1/view/${args?.viewId}/assets`, page, limit, search, view, args);
}

export const loadAsset = async (id) => {

    try {
        const res = await APIGet(`${APIBase}${route}/${id}`)
        const json = await res.json();
        return json;
    } catch (error) {
        return error;
    }

}

export const updateAssetTax = async (id, type, tags) => {

    // const path = (network) ? networkRoute : route;

    // // Args: Are the Cropping and resize args.
    // let qs = [];
    // if (args) Object.keys(args).map(key => qs.push(`${key}=${args[key]}`))

    // const queryString = qs.join('&');

    // try {
    //     const res = await APIGet(`${APIBase}${path}/${id}?${queryString}`)
    //     const json = await res.json();
    //     return json;
    // } catch (error) {
    //     return error;
    // }

}


export const batchDownload = (args) => dispatch => {

    const prefix = 'download';
    const action = `[${model.toUpperCase()}] Download ${model}`;

    // Update The UI
    dispatch(dispatchLoading(action, prefix));



    // Make Request
    APIPost(`${APIBase}${route}/download`, args)
        .then(res => res.json())
        .then(json => {
            if (json.status === 'error') {

                dispatch(dispatchError(action, prefix, json.message))
            }
            else {

                // Dispatch Success
                dispatch(dispatchSuccess(action, prefix, json.message, json.data));

                // Dispatch Clear State
                setTimeout(() => { dispatch(dispatchClearState(action, prefix)) }, 1500)

            }
        })
        .catch(e => {
            // dispatch(openToast(e.message,'error'))
            dispatch(dispatchError(action, prefix, e.message))
        })

}

export const moveAssetToTrash = async (id) => {

    try {
        const res = await APIDelete(`${APIBase}${route}/${id}`)
        const json = await res.json();
        return json;
    } catch (error) {
        return error;
    }

}

export const batchUpdate = (args) => dispatch => {

    return;

    const prefix = 'batchupdate';
    const action = `[${model.toUpperCase()}] Batch Update ${model}`;

    // Update The UI
    dispatch(dispatchLoading(action, prefix));



    // Make Request
    APIPost(`${APIBase}${route}/batchupdate`, args)
        .then(res => res.json())
        .then(json => {
            if (json.status === 'error') {

                dispatch(dispatchError(action, prefix, json.message))
            }
            else {

                // Dispatch Success
                dispatch(dispatchSuccess(action, prefix, json.message, json.data));

                // Dispatch Clear State
                setTimeout(() => { dispatch(dispatchClearState(action, prefix)) }, 1500)

            }
        })
        .catch(e => {
            // dispatch(openToast(e.message,'error'))
            dispatch(dispatchError(action, prefix, e.message))
        })

}